import { ICountryExchangeDetail } from 'types/countries';
import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import { SummarySubmitSection } from 'views/bulkUpload/UploadCatalog/components/SummarySubmitSection/SummarySubmitSection';
import { IUploadInfo } from 'views/bulkUpload/UploadCatalog/content/uploadCatalogInfo';

interface DownloadCatalogStep2Props {
  replaceCatalog: boolean;
  selectedCountry: ICountryExchangeDetail | undefined;
  summaryUploadInfo: IUploadInfo;
  errors: string[];
  errorTemplateURL: string | undefined;
  handleReturnToUpload: () => void;
}

const DownloadCatalogStep2 = ({
  replaceCatalog,
  selectedCountry,
  summaryUploadInfo,
  errors,
  errorTemplateURL,
  handleReturnToUpload
}: DownloadCatalogStep2Props) => {
  return (
    <UploadForm
      backLink="/bulk-upload/type-of-charge"
      confirmationModal={replaceCatalog}
      fileInputIsDisabled={!selectedCountry}
      hideAlert
      hideFileInput
      uploadInfo={summaryUploadInfo}
      customSubmitSection={
        <SummarySubmitSection
          areErrors={errors && errors.length > 0}
          errorTemplateURL={errorTemplateURL}
          handleReturnToUpload={handleReturnToUpload}
        />
      }
      errors={errors}
    />
  );
};

export default DownloadCatalogStep2;
